module.exports = __webpack_public_path__ + "static/media/C_9.60d5f8bb.png";